import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { listDocumentDetails } from "../actions/documentActions";

function Document() {
  let param = useParams();

  const dispatch = useDispatch();
  const documentDetails = useSelector((state) => state.documentDetails);
  const { document } = documentDetails;

  useEffect(() => {
    dispatch(listDocumentDetails(param.id));
  }, [dispatch, param.id]);

  return (
    <Col className="dashboard-scrollable-container" lg={9}>
      <Row className="dashboard-header-container py-3">
        <h3 className="dashboard-header">Document</h3>
      </Row>
      <Row className="dashboard-content-container">
        <Col>
          <Row> {document.title}</Row>
          <Row> {document.content}</Row>
        </Col>
      </Row>
    </Col>
  );
}

export default Document;
